import { matchRoutes } from 'react-router-config'

export default (store, parsedUrl, routes, opts) => {
  const branch = matchRoutes(routes, parsedUrl.pathname)
  return branch.map(({ route, match }) => {
    return route.component.loadData
      ? route.component.loadData(store, parsedUrl, opts)
      : Promise.resolve({
          // resolve empty action
          type: 'noopAction'
        })
  })
}



// WEBPACK FOOTER //
// ./common/utils/fetchAllRequest.js